import { openNotification } from "../../../globals/Components/Notification/Notification";
import { serverMessages, serverMessagesNoOpenNotification } from "../../serverMessages";
import { setErrorMessageResponse, setMessageResponse, toggleErrorIndicator, toggleLoadingIndicator } from "../../system/actions";
import { MessageResponse } from "../../system/types";
import { AppThunk } from "../../thunks";
import { setProducts } from './actions';
import {GetProductsAPI,PosProductsAPI,updateProductaAPI,deleteProductoAPI} from './restCallProducts'


export const updateProduct = (value:object): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await updateProductaAPI(value);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);       
        dispatch(setMessageResponse(message));
        dispatch(toggleLoadingIndicator(false));
        return false
    }
    else if (responseData.StatusCode === 200) {      
        dispatch(setMessageResponse(null));       
        dispatch(toggleLoadingIndicator(false));
        openNotification("","Producto actualizado"); 
        return true
    }
    dispatch(toggleLoadingIndicator(false));
};

export const deleteProducto = (id:string): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await deleteProductoAPI(id);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);
        dispatch(setMessageResponse(message));
        dispatch(toggleLoadingIndicator(false));
        return false
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));
        openNotification("","Producto eliminado");
        return true
    }
    dispatch(toggleLoadingIndicator(false));
};

export const getProducts = (categoria?: string, nombre?: string): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await GetProductsAPI(categoria,nombre);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));
        dispatch(setProducts(responseData.Response)); // ← guarda en el store
        dispatch(toggleLoadingIndicator(false));
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};
export const postProducts = (value: Object): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await PosProductsAPI(value);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));
        openNotification("Ingreso", "Proceso ejcutado correctamente")
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

// export const getProducts = (categoria?: string, nombre?: string): any => async (dispatch: any) => {
//     dispatch(toggleLoadingIndicator(true));

//     const responseData = await GetProductsAPI(categoria, nombre);

//     if (responseData.Error !== null) {
//         dispatch(setMessageResponse(serverMessages(responseData)));
//     } else if (responseData.StatusCode === 200) {
//         dispatch(setProducts(responseData.Response)); // ← limpio
//     }

//     dispatch(toggleLoadingIndicator(false));
// };

